
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Divider, MaintainersCards } from '../../app/components';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: about history team member recruit job career */
    }
    <h1>{`The Brightlayer UI Team`}</h1>
    <MaintainersCards mdxType="MaintainersCards" />
    <Divider mdxType="Divider" />
    <h1>{`A Brief History of Brightlayer UI`}</h1>
    <ul>
      <li parentName="ul">{`The seeds of Brightlayer UI were sown in `}<strong parentName="li">{`2011`}</strong>{` as a single project, Power Xpert Insight.`}</li>
      <li parentName="ul">{`In `}<strong parentName="li">{`2013`}</strong>{`, work on the Power Xpert Insight Gateway exposed a need for a shared design system between similar products.`}</li>
      <li parentName="ul">{`The first iteration of Brightlayer UI, named Power Xpert Blue (PX Blue), was a component library built in Polymer in `}<strong parentName="li">{`2015`}</strong>{`.`}</li>
      <li parentName="ul">{`In the summer of `}<strong parentName="li">{`2017`}</strong>{`, difficulties with the Polymer component library led the team to conduct a full-scale design thinking project to fundamentally rethink how to build an effective design system. The team conducted extensive interviews with designers and developers to understand what they wanted out of our platform.`}</li>
      <li parentName="ul">{`At the end of `}<strong parentName="li">{`2017`}</strong>{`, the team evaluated existing open-source design systems and selected Material Design to serve as the foundation of the new design system.`}</li>
      <li parentName="ul">{`In February of `}<strong parentName="li">{`2018`}</strong>{`, PX Blue 2.0 launches with support for Angular and React.`}</li>
      <li parentName="ul">{`In September `}<strong parentName="li">{`2018`}</strong>{`, PX Blue goes open source and makes all of the resources and materials available to the world. We also added support for developing mobile applications in addition to web.`}</li>
      <li parentName="ul">{`In `}<strong parentName="li">{`2019`}</strong>{`, PX Blue ramped up development of custom component libraries to supplement the components available from Material Design.`}</li>
      <li parentName="ul">{`In `}<strong parentName="li">{`2020`}</strong>{`, the team released an updated CLI for automatically starting new projects with PX Blue integration and began working on new multi-screen re-usable workflows. The team also won `}<a parentName="li" {...{
          "href": "https://www.designinnovationglobal.com/design-thinking/articles/di-global-awards-winners"
        }}>{`two awards`}</a>{`: Brand transformation and Enterprise Design Transformation.`}</li>
      <li parentName="ul">{`In `}<strong parentName="li">{`2021`}</strong>{`, Power Xpert Blue was renamed to Brightlayer User Interface (Brightlayer UI) to better align with the larger Eaton digital strategy.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;